import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from './app/store';
import AppService from './App.service';

export interface VisState {
  displayName: string;
  version: string;
}

const initialState: VisState = {
  displayName: '图智',
  version: '',
};

export const fetchMetaInfo = createAsyncThunk<VisState>(
  'tuzhi.fetchMetaInfo',
  async () => {
    const response = await AppService.getBackendMetaInfo();
    return response.data;
  }
);

export const appSlice = createSlice({
  name: 'meta',
  initialState,
  reducers: {
  },
  extraReducers: builder => {
    builder
      .addCase(fetchMetaInfo.fulfilled, (state, {payload}) => {
        state.displayName = payload.displayName;
        state.version = payload.version;
      });
  }
});

// export const {
// } = appSlice.actions;

export const selectDisplayName = (state: RootState) => state.meta.displayName;
export const selectVersion = (state: RootState) => state.meta.version;

export default appSlice.reducer;
